import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { AgenciaModel } from '@shared/models/backend'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class DadosBancariosService {
  constructor(private http: HttpClient) {}

  loadAgenciaBancaria(codAgencia: string, codBanco: string) {
    let params = new HttpParams()
    params = params.append('codBanco', codBanco)

    return this.http
      .get<AgenciaModel>('/api/dadosBancarios/agencia/' + codAgencia, { params })
      .pipe(take(1))
  }

  verifyAgenciasCadastradasNoBanco(codBanco: string) {
    return this.http.get<boolean>(`/api/dadosBancarios/banco/${codBanco}/agencias/verify`).pipe(take(1))
  }
}
